import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { MyHttpClient } from './my-http-client';

import { environment } from '../../../../environments/environment';

@Injectable()
export class TaxApiClient {
    constructor(private http: MyHttpClient) {}

    getClassifications(classification: string, isLegalPerson: boolean): Observable<string[]> {
        return of(environment.baseHref + 'assets/mock/tax-classifications.json?v=' + environment.version).pipe(
            switchMap((url) => {
                return this.http
                    .get(url)
                    .pipe(
                        map((resp: any[]) =>
                            resp
                                .filter((it) => it.classification === classification && it.isLegalPerson === isLegalPerson)
                                .map((it) => it.code)
                        )
                    );
            })
        );
    }
}
